define('app/sv/validator/sv-validator-factory',[],function () {
	"use strict";
	return svValidatorFactory;
	function svValidatorFactory(options) {
		return angular.extend({
			restrict: "A",
			require: "ngModel",
			scope: false,
			template: null,
			controller: null
		}, (!angular.isArray(options) && angular.isObject(options)) ? options : {
			link: options
		});
	}
});
